// Small dedicated wrapper around localStorage rather than scattering
// these keys across authStore/api.js — both need read/write access to
// the same tokens (api.js's interceptors attach/refresh them, authStore
// persists them on login/logout) without importing each other, which
// would be circular (authStore imports api, so api can't import authStore).
const ACCESS_KEY = "sc_access_token";
const REFRESH_KEY = "sc_refresh_token";

export function getTokens() {
  return {
    accessToken: localStorage.getItem(ACCESS_KEY),
    refreshToken: localStorage.getItem(REFRESH_KEY),
  };
}

export function setTokens({ accessToken, refreshToken } = {}) {
  if (accessToken) localStorage.setItem(ACCESS_KEY, accessToken);
  if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
}

export function clearTokens() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}
